<!-- eslint-disable -->
<template lang="pug">
    div
        .form__title
            slot(name='title')
        form.form__body(action='javascript://' v-if='params')
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.tc('trainer.trainer_gameFormSetting_letters', 1) }}
                .form__field-body
                    cs-multiselect(
                        :options="letters"
                        :show-labels="false"
                        :hide-selected="true"
                        :max="6"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :placeholder="!params.selectedLetters.length ? $i18n.tc('trainer.trainer_gameFormSetting_selectLetters') : ''"
                        :multiple="true"
                        v-model="params.selectedLetters"
                        :disabled="letters.length === 0"
                        v-validate="'required'"
                        data-vv-value-path="innerValue"
                        data-vv-name="letters"
                        :data-vv-as="letters"
                    )
                    help-text(v-if="params.selectedLetters && params.selectedLetters.length < 2", :error="true")
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_moreThanTwoLetters') }}
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfRows') }}
                .form__field-body
                    cs-spin-input(
                        :value="params.amountOfRows",
                        :max="rows",
                        :min="3",
                        @increase="increaseRows",
                        @decrease="decreaseRows",
                        @input="params.amountOfRows = $event",
                    )
            .form__field
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_invertedLetters') }}
                .form__field-body
                    cs-checkbox(
                        v-model='params.invertedLetters',
                    )
            divider
            slot(name='parameters')
            slot(name='help')
            .form__buttons(v-if='!usersIds')
                cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                template(v-if="gameMode === 'free-game'")
                    cs-button.form__button(color="blue", @click='saveGameMode' :disabled="params.selectedLetters.length < 2")
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
                template(v-else='')
                    cs-button.form__button(color="blue", @click='saveGame' :disabled="params.selectedLetters.length < 2")
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
            .form__buttons(v-else='')
                cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                cs-button.form__button(color="blue", @click='saveGame' :disabled="params.selectedLetters.length < 2")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_saveDifference') }}
</template>

<script>
    /*eslint-disable*/
    import GameFormMixin from "../../../utils/trainer/GameFormMixin";
    import TrainerGames from '../../../config/trainer';
    import { getInitParameters } from "../../../utils/trainer/getInitParameters";
    import { mapState } from 'vuex';
    import _ from "lodash";
    import multiplayerFormMixin from "../../../utils/multiplayer/formMixin";
    import availableAlphabets from '../../../config/availableAlphabets.js';

    const AVAILABLE_LANGUAGES = ['ru', 'uk'];

    export default {
        props: [
            'slug',
            'courseType',
            'id',
            'usersIds',
            'homeworkId',
            'gameMode',
            'levelAnswerDuration',
            'gameId',
            'generatorSettings',
            'generatorGameIndex'
        ],
        mixins: [GameFormMixin, multiplayerFormMixin],
        data () {
            return {
                alphabets: availableAlphabets,
                params: null,
                rows: 20,
            }
        },
        mounted () {
            if (this.gameMode === 'free-game') {
                let paramsArray = this.$store.state.trainer.paramsArray;
                if (paramsArray && paramsArray[0] && paramsArray[0].slug === this.slug) {
                    this.paramsArray = _.cloneDeep(paramsArray);
                    this.$emit('playersNumber', this.paramsArray.length);
                    this.params = this.paramsArray[0];
                } else if (this.gamesParameters) {
                    this.$set(this, 'params', getInitParameters({
                        slug: this.slug,
                        parameters: {
                            default: _.cloneDeep(this.gamesParameters[this.slug])
                        }
                    }));
                } else {
                    this.params = _.cloneDeep(TrainerGames.games).find(item => item.slug === this.slug).parameters.default;
                }
            } else {
                this.setInitParams(this.getKey(this.usersIds));
            }
        },
        watch: {
            'params.selectedLetters': {
                handler (array) {
                    if (array.length >= 6) {
                        this.$nextTick(() => {
                            document.querySelector('.multiselect__option').innerText = this.$i18n.t('trainer.trainer_gameFormSettings_maxAmountOfElements');
                        });
                    }
                }
            }
        },
        methods: {
            decreaseRows() {
                if (this.params.amountOfRows !== 3) {
                    this.params.amountOfRows -= 1;
                }
            },
            increaseRows() {
                if (this.params.amountOfRows !== this.rows) {
                    this.params.amountOfRows += 1;
                }
            }
        },
        computed: {
            ...mapState({
                homework: state => state.trainer.homework,
                gamesParameters: state => state.trainer.gamesParameters,
                user: state => state.auth.user
            }),
            letters () {
                if (this.currentCourseType === 'readingEn') {
                    return this.alphabets.en;
                }
                if (AVAILABLE_LANGUAGES.includes(this.user.locale)) {
                    return this.alphabets[this.user.locale];
                }
                return this.alphabets.ru;
            },
            currentCourseType() {
                if (this.courseType) return this.courseType;
                if (this.$route.params.coursesType) return this.$route.params.coursesType;
                if (this.homework?.games[this.$route.params.gameId].courseType)
                    return _.camelCase(this.homework.games[this.$route.params.gameId].courseType);
                return null;
            },
        },
    }
</script>

<style lang="scss" scoped>
    .form__title {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        margin-bottom: 25px;
    }

    .form__body {
        width: 100%;
        box-sizing: border-box;
        @include media($lg) {
            padding: 0 4.5%;
        }
    }

    .form__field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            padding: 0 10%;
        }
        @include media($xlg) {
            padding: 0 13%;
        }
    }
    .form__label {
        min-width: 0;
        font-size: 16px;
        line-height: 19px;
        margin-right: 20px;
        margin-bottom: .5rem;
        @include media($md) {
            width: 8em;
            margin-bottom: 0;
            text-align: right;
        }
        @include media($xlg) {
            max-width: none;
            min-width: 13em;
        }
    }

    .form__field-body {
        flex-grow: 5;
    }

    .form__buttons {
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        @include media($md) {
            flex-direction: row;
        }
    }

    .form__button {
        margin: 10px 50px;
        @include media($md) {
            margin: 0 10px;
        }
    }
</style>

